export type Denomination = 'thousands' | 'lacs' | 'crores';

export const denominationMultipliers: Record<Denomination, number> = {
  thousands: 1000,
  lacs: 100000,
  crores: 10000000,
};

export const availableBidIncrements: Array<{
  value: number;
  label: string;
  denomination: string;
}> = [
  { value: 10000, label: '10K', denomination: 'thousands' },
  { value: 25000, label: '25K', denomination: 'thousands' },
  { value: 50000, label: '50K', denomination: 'thousands' },
  { value: 100000, label: '1 Lac', denomination: 'lacs' },
  { value: 200000, label: '2 Lacs', denomination: 'lacs' },
  { value: 500000, label: '5 Lacs', denomination: 'lacs' },
  { value: 1000000, label: '10 Lacs', denomination: 'lacs' },
  { value: 2000000, label: '20 Lacs', denomination: 'lacs' },
  { value: 5000000, label: '50 Lacs', denomination: 'lacs' },
  { value: 10000000, label: '1 Crore', denomination: 'crores' },
] as const;

export function getLogicalBidIncrements(baseBudget: number) {
  // Only return increments that are at most 20% of the base budget
  const maxIncrement = baseBudget * 0.2;
  return availableBidIncrements.filter((inc) => inc.value <= maxIncrement);
}

export function convertToRaw(
  amount: number,
  denomination: Denomination
): number {
  return amount * denominationMultipliers[denomination];
}
